<template>
  <div v-if="workflow">
    <div class="p-x-8 p-y-4">
      <h2 class="p-x-1">{{ workflow.title }}</h2>
      <div v-if="workflow.metadata" class="card">
        <p>{{ workflow.metadata.description }}</p>
      </div>

      <div  v-if="workflow.metadata" class="workflow-details card">
        <ul>
          <li>Contributors: {{ workflow.metadata.contributors }}</li>
          <li>Last Modified By: {{ workflow.metadata.last_modified.by }}</li>
          <li>Last Run On: {{ workflow.metadata.last_modified.date }}</li>
          <li>Total Data Consumed: {{ workflow.metadata.data_consumed.size }} rows ({{ workflow.metadata.data_consumed.rows }})</li>
        </ul>
      </div>

    </div>
    <!-- <TreeChart :nodes="workflow.nodes" :edges="workflow.edges" :key="workflow.title" /> -->
    <WorkFlowChart :data="workflow" :key="JSON.stringify(workflow)" />
  </div>
  <div v-else>
    <p>No workflow selected</p>
  </div>
</template>

<script>
// import TreeChart from '@/components/TreeChart.vue';
import WorkFlowChart from './WorkFlowChart.vue';
export default {
  props: ['workflow'],
  components: { WorkFlowChart }
};
</script>

<style scoped>
  .card{
    background-color: rgb(237, 236, 235);
    border: 1.5px solid #605f5f;
    max-width: 60%;
    padding: 10px;
    border-radius: 20px;
    margin-top: 10px;
  }
  ul li{
    list-style: none;
  }
</style>
